import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Chip,
  Fab,
  Icon,
  makeStyles,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { qualityClassColor } from '../../../../../../helpers/manageColors';

const useStyles = makeStyles((theme) => ({
  fabs_general: {
    background: 'transparent',
    width: '24px',
    height: '24px',
    minHeight: '24px',
    zIndex: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      boxShadow: '0px 0px 5px 1px rgb(115 115 115)',
    },
  },
}));

const ProjectionFabs = ({
  chipIcon,
  evaluationClass,
  tooltipText,
  chipAction,
  extraStyles,
  tooltipAction,
  tooltipLeave,
  clickableChip,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const qualityInRevision = useSelector((state) => state.labeling?.qualityInRevisionMode);
  const examinationListDrawer = useSelector((state) => state.gui.examinationListDrawer);
  const smallScreen = useMediaQuery('(max-width: 1450px)') || examinationListDrawer;

  return (
    <Tooltip
      title={tooltipText}
      placement='left-end'
      arrow
      onOpen={() => tooltipAction && tooltipAction(true)}
      onClose={() => tooltipLeave && tooltipLeave(false)}
    >
      <Avatar
        size='small'
        className={classes.fabs_general}
        onClick={() => {
          if (chipAction && (clickableChip || qualityInRevision)) {
            chipAction();
          } else {
            return;
          }
        }}
        style={{
          cursor: clickableChip || qualityInRevision ? 'pointer' : 'help',
          background: smallScreen
            ? 'transparent'
            : evaluationClass
            ? `${qualityClassColor(evaluationClass, theme)}10`
            : 'transparent',
          ...extraStyles,
        }}
      >
        {chipIcon}
      </Avatar>
    </Tooltip>
  );
};

ProjectionFabs.propTypes = {
  chipIcon: PropTypes.element,
  evaluationClass: PropTypes.string,
  chipAction: PropTypes.func,
  tooltipText: PropTypes.node.isRequired,
  extraStyles: PropTypes.object,
  tooltipLeave: PropTypes.func,
  tooltipAction: PropTypes.func,
};

ProjectionFabs.defaultProps = {
  chipIcon: null,
  evaluationClass: '',
  chipAction: null,
  tooltipText: '',
  extraStyles: {},
  tooltipLeave: null,
  tooltipAction: null,
};

export default ProjectionFabs;
